export const GET_ALL_STORES = "groupStates/GET_ALL_STORES";
export const GET_MASTER_STORE = "groupStates/GET_MASTER_STORE";
export const GET_SUB_STORES = "groupStates/GET_SUB_STORES";
export const GET_SELECTED_STORE = "groupStates/GET_SELECTED_STORE";
export const SET_VALUE_IN_STORE = "groupStates/SET_VALUE_IN_STORE";
export const SAVE_STORE = "groupStates/SAVE_STORE";

